// extracted by mini-css-extract-plugin
module.exports = {"brand-container":"Brand_brand-container__3di6V","logo":"Brand_logo__WtpWC","custom":"Brand_custom__1k1S2"};